'use client';

/* empty css                            */
var defaultBodyFontFamily = "Inter";
var bodyFontVars = { fontFamily: "var(--c5-21-2_odhvdm0)" };
var bodyFontThemes = { sourceSans: "c5-21-2_odhvdm1", notoSerif: "c5-21-2_odhvdm2", lato: "c5-21-2_odhvdm3", montserrat: "c5-21-2_odhvdm4", openSans: "c5-21-2_odhvdm5", raleway: "c5-21-2_odhvdm6" };
export {
  bodyFontThemes,
  bodyFontVars,
  defaultBodyFontFamily
};
